export default "__VITE_ASSET__36c5ce85__"